package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.px

// Style du conteneur FormCard
val FormCardStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .borderRadius(12.px)
            .padding(15.px)
            .styleModifier {
                property("box-sizing", "border-box")
                property("min-width", "0")
            }
    }
    Breakpoint.MD {
        Modifier.padding(20.px)
    }
}

// Style de la rangée de résumé (GenericFormCard)
val GenericSummaryRowStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .minWidth(0.px)
            .padding(12.px)
    }

    Breakpoint.MD {
        Modifier.padding(20.px)
    }
}

// Style du titre du résumé
val SummaryTitleStyle = CssStyle {
    base {
        Modifier.fontSize(14.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(18.px)
    }
}

// Style du sous-titre du résumé
val SummarySubtitleStyle = CssStyle {
    base {
        Modifier.fontSize(12.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(16.px)
    }
}

// Style du texte par défaut (lorsqu'il n'y a pas encore de données)
val SummaryDefaultTextStyle = CssStyle {
    base {
        Modifier.fontSize(14.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(18.px)
    }
}

// Style du conteneur du bouton d'édition
val EditButtonBoxStyle = CssStyle {
    base {
        Modifier.size(32.px)
    }
    Breakpoint.MD {
        Modifier.size(40.px)
    }
}

// Style de l'icône à l'intérieur du bouton d'édition
val EditButtonIconStyle = CssStyle {
    base {
        Modifier.fontSize(8.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(15.px)
    }
}